import React, { Component } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';

import PracticeEditModal from '../../../../components/PracticeEditModal';
import * as api from '../../../../services/api/admin';

class Practices extends Component {
  state = {
    isLoading: true,
    practices: [],
    practiceUnderEdit: {},
    openPracticeEditModal: false,
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      await this.fetchPractices();
    } catch (err) {
      console.error(err);
      this.props.enqueueSnackbar(
        'Unable to fetch providers, please refresh the page to try again.'
      );
    } finally {
      this.setState({ isLoading: false });
    }
  }

  fetchPractices = async () => {
    const practices = await api.fetchPractices();
    this.setState({ practices });
  };

  onNewPractice = async () => {
    this.setState({ openPracticeEditModal: true, practiceUnderEdit: {} });
  };

  onEditPractice = async practice => {
    this.setState({ openPracticeEditModal: true, practiceUnderEdit: practice });
  };

  onSavePractice = async practice => {
    const { enqueueSnackbar } = this.props;
    try {
      if (practice.id) {
        await api.updatePractice(practice);
      } else {
        await api.createPractice(practice);
      }
      enqueueSnackbar('Practice updated!');
      this.onClose();
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Unable to save practice, please try again.');
    } finally {
      this.fetchPractices();
    }
  };

  onClose = () => {
    this.setState({ openPracticeEditModal: false, practiceUnderEdit: {} });
  };

  render() {
    const { classes } = this.props;
    const {
      isLoading,
      practices,
      practiceUnderEdit,
      openPracticeEditModal,
    } = this.state;

    if (isLoading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }

    return (
      <>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell># of Providers</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {practices.map(practice => (
              <TableRow key={practice.id}>
                <TableCell width="400">{practice.name}</TableCell>
                <TableCell width="400">{practice.providers.length}</TableCell>
                <TableCell>
                  <IconButton onClick={() => this.onEditPractice(practice)}>
                    <EditIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        <Grid
          container
          justifyContent="flex-end"
          classes={{ container: classes.actions }}
        >
          <Grid item xs={12} md={4} lg={2}>
            <Button
              fullWidth
              color="primary"
              variant="contained"
              onClick={this.onNewPractice}
            >
              + Add Practice
            </Button>
          </Grid>
        </Grid>

        {openPracticeEditModal && (
          <PracticeEditModal
            practice={practiceUnderEdit}
            open={openPracticeEditModal}
            save={this.onSavePractice}
            onClose={this.onClose}
          />
        )}
      </>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  actions: {
    marginTop: '2em',
  },
});

export default withSnackbar(withStyles(styles)(Practices));
